import { render } from "./LocationNotificationsSettings.vue?vue&type=template&id=b76eec88&scoped=true"
import script from "./LocationNotificationsSettings.vue?vue&type=script&lang=js"
export * from "./LocationNotificationsSettings.vue?vue&type=script&lang=js"

import "./LocationNotificationsSettings.vue?vue&type=style&index=0&id=b76eec88&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b76eec88"]])

export default __exports__